/* https://github.com/nathanreyes/v-calendar/tree/next */
import { app } from "@/main";
import VCalendar from "v-calendar";
import "v-calendar/dist/style.css";

// Use plugin with defaults configuration
app.use(VCalendar, {});
